import { useCallback, useMemo } from 'react';
import NiceModal from '@ebay/nice-modal-react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { Chains, ChainsBroken } from 'components/atoms/CustomSVGIcon';
import Sidebar from 'components/atoms/GefMui/Sidebar/Sidebar';
import MODALS from 'constants/modals';
import contactDetail from 'features/views/contactDetail';
import contactList from 'features/views/contactList';

import Client from './Client';
import Owner from './Owner';
import Policy from './Policy';

export const ContactDetailSidebar = () => {
	const contact = useSelector(contactDetail.selectors.getDetail);
	const { solutionStateId, hasBrutto } = contact;

	const isContactInSuccessfullState = useSelector((state) =>
		contactList.selectors.getIsContactInSuccessfullState(state, solutionStateId),
	);

	const handleOpenBruttoProductionModal = useCallback(() => {
		NiceModal.show(MODALS.brutto_production, { contact });
	}, [contact]);

	const bruttoIcon = useMemo(() => {
		if (isContactInSuccessfullState) {
			if (hasBrutto) {
				return (
					<Chains
						style={{ color: 'green', fontSize: '20px' }}
						className="Link"
						onClick={handleOpenBruttoProductionModal}
					/>
				);
			} else {
				return <ChainsBroken style={{ color: 'red', fontSize: '20px' }} />;
			}
		} else {
			return null;
		}
	}, [isContactInSuccessfullState, hasBrutto, handleOpenBruttoProductionModal]);

	return (
		<Sidebar>
			<Sidebar.Body spacing={2} sx={{ p: 3, maxHeight: 'unset !important' }}>
				{isContactInSuccessfullState && (
					<Stack
						direction="row"
						sx={{
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<Typography variant="h6" color="text.primary">
							{getLabelMessage('contactDetail:bruttoProduction')}
						</Typography>
						{bruttoIcon}
					</Stack>
				)}
				<Owner contact={contact} />
				<Client contact={contact} />
				<Policy contact={contact} />
			</Sidebar.Body>
		</Sidebar>
	);
};

export default ContactDetailSidebar;
